<template>
  <div>
    <v-row
      :class="checkIsMobile() && checkIsTablet() ? 'no-margin' : ''"
      v-if="sportBanners.length"
    >
      <v-col
        cols="12"
        md="12"
        :class="checkIsMobile() && checkIsTablet() ? '' : 'pb-5'"
      >
        <v-carousel
          cycle
          :height="!checkIsMobile() && !checkIsTablet() ? 240 : 'auto'"
          hide-delimiters
          :show-arrows="sportBanners.length > 1"
          class="slider-center-desktop"
        >
          <v-carousel-item
            v-for="(slide, i) in sportBanners"
            :key="$uuid.v1()"
            next-icon=""
            prev-icon=""
            link
            :href="slide.link"
            target="_parent"
          >
            <v-img :src="slide.image" :title="slide.title"></v-img>
          </v-carousel-item>
        </v-carousel>
      </v-col>
    </v-row>
  </div>
</template>

<script>
import { mapActions, mapGetters } from 'vuex'
import { isMobileOnly } from 'mobile-device-detect'
import { isTablet } from 'mobile-device-detect'
import {
  checkIsMobileDevice,
  checkIsTabletDevice,
} from '@/plugins/device-inspector'
import axios from 'axios'
// import _ from "lodash"

export default {
  name: 'ImagesSlider',
  props: ['sportBanners'],
  data: () => ({
    isMobileOnly: isMobileOnly,
    isTablet: isTablet,
    pathImages: process.env.VUE_APP_URL_CLOUDFRONT,
    /*slides: [],*/
  }),

  computed: {
    ...mapGetters({
      getAuthenticated: 'user/getAuthenticated',
      getId: 'user/getId',
      getLogin: 'user/getLogin',
      getPlatformSettings: 'settings/getPlatformSettings',
      getBanners: 'settings/getBanners',
    }),
  },
  methods: {
    ...mapActions({}),

    checkIsMobile() {
      return checkIsMobileDevice()
    },

    checkIsTablet() {
      return checkIsTabletDevice()
    },
  },
  watch: {
    getBanners() {
      const banners = this.getBanners
      _.forEach(banners, bann => {
        if (bann.type == 1) {
          this.sportBanners.push({
            image: bann.image,
            link: bann.link,
            title: bann.name,
          })
        }
      })
    },
  },
  async beforeCreate() {},
  async mounted() {},
}
</script>
